import React from "react";
import styles from "./styles.less";

/*
  pointCount refers to points in this cluster
  totalPointCount refers to points on whole map
*/
const ClusterMarker = props => {
  const { mapRef, clusterId, supercluster, lat, lng, clusterPointCount, totalPointCount } = props;
  const clusterDiameter = `${20 + (clusterPointCount / totalPointCount) * 40}px`;

  return (
    <div
      className={styles.clusterMarker}
      style={{
        width: clusterDiameter,
        height: clusterDiameter,
      }}
      onClick={() => {
        const expansionZoom = supercluster.getClusterExpansionZoom(clusterId);
        mapRef.current.setZoom(expansionZoom);
        mapRef.current.panTo({ lat, lng });
      }}
    >
      {clusterPointCount}
    </div>
  );
};

export default ClusterMarker;
